import { z } from 'zod';

export const searchSchema = z.object({
  tk: z.string().optional(),
  ngay_ct: z.string(),
  loai_sd: z.string(),
  group_by: z.array(z.number()).optional(),
  mau_bc: z.coerce.number()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialValues: SearchFormValues = {
  ngay_ct: new Date().toISOString().split('T')[0],
  loai_sd: '1',
  group_by: [],
  mau_bc: 20
};
